<template>
    <div>
        Verifying
    </div>
</template>


<script>

import helpers from '@/libs/helpers.js'

export default {
    data () {
        return {
            code: null
        }
    },
    created () {
        this.code = helpers.getParameterByName('code')

        if (this.code) {
            this.$http.get('GEauth/token', {
                params: {
                    code: this.code
                }
            }).then(res => {
                console.log(res.data)

                if (res.data.code == 1) {

                    this.$cookie.set('access_token', res.data.data.access_token)
                    this.$cookie.set('refresh_token', res.data.data.refresh_token)

                    this.$bvToast.toast('Đăng nhập thành công!', {
                        title: `Thông báo!`,
                        variant: 'success',
                        solid: true
                    })
                } else {
                    this.$bvToast.toast('Đăng nhập thất bại!', {
                        title: `Có lỗi xảy ra!`,
                        variant: 'danger',
                        solid: true
                    })
                }

                this.redirecTo('/')
            })
        } else {
            this.redirecTo('/')
        }
    },
    methods: {
        redirecTo (path) {
            this.$router.push({
                path: path
            })
        }
    }
}
</script>